<template>
  <v-container grid-list-md fluid>
    <v-layout wrap>
      <v-flex xs12 lg6>
        <v-layout wrap align-center justify-center>
          <v-flex xs12 sm7>
            <span class="headline">Receitas e Despesas da Atividade Rural</span>
          </v-flex>
          <v-flex xs12 sm4>
            <v-btn block color="primary" @click="openModal(1)">
              {{ this.translate("system.button.manage.title") }}
              <v-icon dark right>{{ this.translate("system.button.manage.icon") }}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm1>
            <v-menu offset-y>
              <v-btn slot="activator" icon class="ml-2" title="Relatórios">
                <v-icon>description</v-icon>
              </v-btn>
              <v-list>
                <!-- PDF -->
                <v-list-tile @click="exportReport(1, 'receita_despesa')">
                  <v-list-tile-action>
                    <v-icon color="red darken-1">picture_as_pdf</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Relatório em PDF</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <!-- Excel -->
                <v-list-tile @click="exportReport(2, 'receita_despesa')">
                  <v-list-tile-action>
                    <v-icon color="green darken-2">table_chart</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Relatório em Excel</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers.receita_despesa"
              :items="editedItem"
              class="elevation-1"
              rows-per-page-text="Registros por página"
              :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
              no-data-text="Não existem registros"
              no-results-text="Nenhum registro encontrado"
            >
              <template slot="items" slot-scope="props">
                <td class="subheading">{{ meses[props.item.mes_base - 1] }}</td>
                <td class="text-xs-right">
                  {{ props.item.receita | formatCurrency }}
                </td>
                <td class="text-xs-right">
                  {{ props.item.despesa | formatCurrency }}
                </td>
                <td class="text-xs-right">
                  {{ (props.item.receita - props.item.despesa) | formatCurrency }}
                </td>
              </template>
              <template slot="footer">
                <td><strong>Total</strong></td>
                <td class="text-xs-right">{{ total_receita | formatCurrency }}</td>
                <td class="text-xs-right">{{ total_despesa | formatCurrency }}</td>
                <td class="text-xs-right">
                  {{ (total_receita - total_despesa) | formatCurrency }}
                </td>
              </template>
              <template slot="pageText" slot-scope="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 lg6>
        <v-layout wrap align-center justify-center>
          <v-flex xs12 sm11>
            <span class="headline">Liberações e Pagamentos da Atividade Rural</span>
          </v-flex>
          <v-flex xs12 sm1>
            <v-menu offset-y>
              <v-btn slot="activator" icon class="ml-2" title="Relatórios">
                <v-icon>description</v-icon>
              </v-btn>
              <v-list>
                <!-- PDF -->
                <v-list-tile @click="exportReport(1, 'liberacao_pagamento')">
                  <v-list-tile-action>
                    <v-icon color="red darken-1">picture_as_pdf</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Relatório em PDF</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <!-- Excel -->
                <v-list-tile @click="exportReport(2, 'liberacao_pagamento')">
                  <v-list-tile-action>
                    <v-icon color="green darken-2">table_chart</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Relatório em Excel</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="headers.liberacao_pagamento"
              :items="editedItem"
              class="elevation-1"
              rows-per-page-text="Registros por página"
              :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
              no-data-text="Não existem registros"
              no-results-text="Nenhum registro encontrado"
            >
              <template slot="items" slot-scope="props">
                <td class="subheading">{{ meses[props.item.mes_base - 1] }}</td>
                <td class="text-xs-right">
                  {{ props.item.liberacao_total | formatCurrency }}
                </td>
                <td class="text-xs-right">
                  {{ props.item.pagamento_total | formatCurrency }}
                </td>
                <td class="text-xs-right">
                  {{ (props.item.liberacao_total - props.item.pagamento_total) | formatCurrency }}
                </td>
              </template>
              <template slot="footer">
                <td><strong>Total</strong></td>
                <td class="text-xs-right">{{ total_liberacao | formatCurrency }}</td>
                <td class="text-xs-right">{{ total_pagamento | formatCurrency }}</td>
                <td class="text-xs-right">
                  {{ (total_liberacao - total_pagamento) | formatCurrency }}
                </td>
              </template>
              <template slot="pageText" slot-scope="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" scrollable max-width="1600px" persistent>
      <v-card>
        <v-card-title>
        <v-flex xs11>
          <span class="display-1">{{ "Gerenciamento de Receitas e Despesas" }}</span>
        </v-flex>
        <v-flex xs1>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" @click="atualizarValores">refresh</v-icon>
            </template>
            <span>
              Preencher com Controle de Caixa
            </span>
          </v-tooltip>
        </v-flex>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <v-data-table
                  :headers="form.headers"
                  :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
                  :items="editedItem"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="subheading">{{ meses[props.item.mes_base - 1] }}</td>
                    <td>
                      <p-money
                        name="liberacao"
                        class="custon-input"
                        v-model="props.item.receita"
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <p-money
                        name="despesa"
                        class="custon-input"
                        v-model="props.item.despesa"
                        :v_validate="'positiveNumber'"
                      ></p-money>
                    </td>
                    <td>
                      <money
                        class="custom-input"
                        disabled
                        v-bind="money"
                        :value="Number(props.item.receita - props.item.despesa)"
                      ></money>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="mx-1"
            color="primary darken-2"
            :disabled="saving"
            :loading="saving"
            @click.native="save('movimentacaofinanceira')"
          >
            Salvar
          </v-btn>
          <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import money from "v-money";
import crud from "./../../mixin/crud";
import PMoney from "../shared/PMoney";

Vue.use(money, { precision: 4 });

export default {
  components: { PMoney },
  mixins: [crud],
  data: () => ({
    entity: "condominio_movimentacaofinanceira",
    meses: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    items: [],
    form: {
      type: "",
      title: "",
      headers: [],
    },
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
    editedItem: [],
  }),
  name: "MovimentacaoFinanceira",
  props: ["condominio_id"],
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.beforeInitialize();
      this.$store.commit("loader/change_dialog", true);
      this.$http
        .get(
          `api/movimentacaofinanceira${
            this.condominio_id ? "?where=condominio_id=" + this.condominio_id : ""
          }`
        )
        .then(
          (res) => {
            this.resBody = res.body;
            this.editedItem = res.body.dados;
            this.afterInitialize();
            this.$store.commit("loader/change_dialog", false);
          },
          (err) => {
            this.afterInitialize();
            this.$store.commit("loader/change_dialog", false);
          }
        );
    },
    close(time = 0, to = 1) {
      this.beforeClose();
      this.dialog = to !== 1;
      this.$store.commit("loader/change_dialog", false);
      setTimeout(() => {
        if (to !== 3) {
          this.editedIndex = -1;
        }
        this.view = to;
        this.afterClose();
      }, time);
    },
    openModal(type) {
      this.defaultItem = JSON.parse(JSON.stringify(this.editedItem));
      this.create();
    },
    save() {
      if (this.saving) return;
      this.saving = true;
      this.$http.put("api/movimentacaofinanceira/update_many", this.editedItem).then(
        (res) => {
          this.editedItem = JSON.parse(JSON.stringify(res.body));
          this.saving = false;
        },
        (err) => {
          this.saving = false;
          alert("Erro! Falha ao enviar a requisição.");
          console.log(err);
        }
      );

      this.dialog = false;
      this.$store.commit("loader/change_dialog", false);
      setTimeout(() => {
        this.editedIndex = -1;
        this.view = 1;
      }, 400);
    },
    atualizarValores () {
      console.log("123");
      this.$store.commit("loader/change_dialog", true);
      this.$http.get(`api/get_controle_caixa_por_mes/${this.condominio_id}`).then(
        (res) => {
          this.$store.commit("loader/change_dialog", false);
          let values = res.body
          // constrói um índice por mês (1..12)
          const valuesByMes = values.reduce((acc, v) => {
            acc[v.mes] = v;
            return acc;
          }, {});

          // atualiza receita/despesa em cada linha do editedItem
          this.editedItem.forEach(row => {
            const match = valuesByMes[row.mes_base];
            if (match) {
              row.receita = Number(match.entrada) || 0;
              row.despesa = Number(match.saida) || 0;
            }
          });
        },
        (err) => {
          this.$store.commit("snackbar/change_values", {
            text: "Não foi possível carregar os dados.",
            color: "error",
            dialog: true,
          });
          this.$store.commit("loader/change_dialog", false);
        }
      );
    },
    // type 1 = pdf 2 = excel
    // reportType: 'receita_despesa' ou 'liberacao_pagamento'
    exportReport (type, reportType) {
      this.$store.commit("loader/change_dialog", true);
      const tableName = reportType === 'receita_despesa'
        ? 'condominio_movimentacaofinanceira_receita_despesa'
        : 'condominio_movimentacaofinanceira_liberacao_pagamento';

      this.$http.put(`report/report_details/${this.condominio_id}`, {
        "type": type,
        "table": tableName
      }).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          const _this = this;
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    }
  },
  computed: {
    total_receita: function () {
      // Verifica se this.editedItem é um array
      if (Array.isArray(this.editedItem)) {
        // Se for um array, usa o método reduce()
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.receita;
        }, 0);
      } else {
        // Se não for um array, retorna 0 ou outro valor padrão
        return 0;
      }
    },
    total_despesa: function () {
      if (Array.isArray(this.editedItem)) {
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.despesa;
        }, 0);
      } else {
        return 0;
      }
    },
    total_liberacao: function () {
      if (Array.isArray(this.editedItem)) {
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.liberacao_total;
        }, 0);
      } else {
        return 0;
      }
    },
    total_pagamento: function () {
      if (Array.isArray(this.editedItem)) {
        return this.editedItem.reduce(function (sum, item) {
          return sum + item.pagamento_total;
        }, 0);
      } else {
        return 0;
      }
    },
    headers: function () {
      return {
        receita_despesa: [
          {
            text: this.translate("table." + this.entity + ".field.mes_base"),
            sortable: false,
            value: "mes_base",
          },
          {
            text: this.translate("table." + this.entity + ".field.receita"),
            sortable: false,
            value: "receita",
            align: "right",
          },
          {
            text: this.translate("table." + this.entity + ".field.despesa"),
            sortable: false,
            value: "despesa",
            align: "right",
          },
          {
            text: this.translate("table." + this.entity + ".field.resultado"),
            sortable: false,
            value: "resultado",
            align: "right",
          },
        ],
        liberacao_pagamento: [
          {
            text: this.translate("table." + this.entity + ".field.mes_base"),
            sortable: false,
            value: "mes_base",
          },
          {
            text: this.translate("table." + this.entity + ".field.liberacao"),
            sortable: false,
            value: "liberacao",
            align: "right",
          },
          {
            text: this.translate("table." + this.entity + ".field.pagamento"),
            sortable: false,
            value: "pagamento",
            align: "right",
          },
          {
            text: this.translate("table." + this.entity + ".field.resultado"),
            sortable: false,
            value: "resultado",
            align: "right",
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.custon-input {
  outline-width: 0;
  height: 30px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  border-bottom: 1px solid #949494;
  width: 100%;
}

tbody tr:nth-child(odd) {
  background: #e8f5e9;
}
</style>



// WEBPACK FOOTER //
// src/components/details/MovimentacaoFinanceira.vue